@if (display) {
  <div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <!-- <div class="layout-sidebar" style="z-index: 99999;"> -->
    <div class="layout-sidebar">
      <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container" style="position: relative">
      <div class="layout-main" style="width: -webkit-fill-available">
        <!-- <app-breadcrumbs /> -->

        <div class="loader-fader" style="z-index: 10" [style.opacity]="isDownloadingChunk() ? 0 : 1">
          <router-outlet></router-outlet>
        </div>
      </div>
      <div
        class="flex justify-content-center align-items-center loader-fader"
        style="position: absolute; inset: 0; height: 100dvh;"
        [style.opacity]="isDownloadingChunk() ? 1 : 0"
        [style.z-index]="isDownloadingChunk() ? 10 : -1"
      >
        <p-progressSpinner></p-progressSpinner>
      </div>
      <app-footer></app-footer>
    </div>
    <app-config></app-config>
    <div class="layout-mask"></div>
  </div>
} @else {
  <div class="layout-wrapper p-4 flex justify-content-center align-items-center" [ngClass]="containerClass">
    <router-outlet></router-outlet>
  </div>
}
